import { UNIFIED_PLAN_CHOOSE } from "./actionTypes";

export default (planId, duration) => ({
  type: UNIFIED_PLAN_CHOOSE,
  payload: {
    planId,
    duration,
  },
});
